import {useEffect} from 'react'
import ReactPixel from 'react-facebook-pixel'

const advancedMatching = {}

const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false, // enable logs
}

const useFacebookPixel = () => {
    useEffect(() => {
        ReactPixel.init('6317436544958984', advancedMatching, options)
        ReactPixel.pageView() // For tracking page view
    }, [])
}

export default useFacebookPixel
